"use client";
import { SetStateAction, useState } from "react";
import { AI_NAME } from "@/features/theme/ui-strings";
import { signIn } from "next-auth/react";
import { FC } from "react";
import { Avatar, AvatarImage } from "../ui/avatar";
import { Button } from "../ui/button";
import Link from "next/link";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";

interface LoginProps {
  isDevMode: boolean;
}

export const LogIn: FC<LoginProps> = (props) => {
  const [isDisabled, setIsDisabled] = useState<boolean>(true);

  const onChangeCheckBox = (e: {
    target: { checked: boolean; value: React.SetStateAction<string> };
  }) => {
    const { value, checked: isChecked } = e.target;

    setIsDisabled(!e.target.checked);
  };

  return (
    <Card className="flex gap-2 flex-col min-w-[300px]">
      <CardHeader className="gap-2">
        <CardTitle className="text-2xl flex-col self-center">
          <span className="dark:hidden">
            <img className="h-24 object-scale-down" src={"ask-BDO-AI_freigestellt.png"} />
          </span>
          <span className="hidden dark:block">
            <img
              className="dark:h-24 dark:object-scale-down"
              src={"ask-BDO-AI_white-transparent.png"}
            />
          </span>
        </CardTitle>
        <CardDescription>Bitte melden Sie sich mit Ihrem Microsoft 365 Zugang an.</CardDescription>
      </CardHeader>
      <CardContent className="grid gap-4">
        <div>
          <input
            type="checkbox"
            value=""
            title="Erstnutzerhinweis"
            name="time"
            onChange={onChangeCheckBox}
          />
          <span>
            {" "}
            Hiermit bestätigen Sie, dass Sie die{" "}
            <Link
              style={{ textDecoration: "underline", color: "#33a0ff" }}
              href="https://bdo365ge.sharepoint.com/:b:/r/sites/bdo-bdokikompass/KnowledgeHub/KI%20Nutzungshinweise/Nutzungshinweise%20ask%20BDO%20AI.pdf?csf=1&web=1&e=v49qQP"
              target="neu"
            >
              Erstnutzungshinweise
            </Link>{" "}
            sowie die{" "}
            <Link
              style={{ textDecoration: "underline", color: "#33a0ff" }}
              href="https://bdo365ge.sharepoint.com/:b:/r/sites/bdo-bdokikompass/KnowledgeHub/Informationen%20nach%20Art.%2013%20DSGVO%20f%C3%BCr%20die%20berufliche%20Nutzung%20von%20BDO%20ChatGPT.pdf?csf=1&web=1&e=wlIVsY"
              target="neu"
            >
              Datenschutzhinweise
            </Link>{" "}
            gelesen haben.
          </span>
          <br />
          <br />
        </div>
        <Button disabled={isDisabled} onClick={() => signIn("azure-ad")}>
          Anmelden...
        </Button>
        {props.isDevMode ? (
          <Button disabled={isDisabled} onClick={() => signIn("localdev")}>
            Anmelden mit Basic Auth (DEV ONLY)
          </Button>
        ) : null}
      </CardContent>
    </Card>
  );
};
